import { useState } from "react";
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";

function Layout({ children }) {
    const [isCollapsed, setIsCollapsed] = useState(false);

    const toggleSidebar = () => setIsCollapsed(!isCollapsed);

    return (
        <div style={{ display: "flex", background: "var(--bg-main)", minHeight: "100vh" }}>
            <Sidebar isCollapsed={isCollapsed} />

            <div className="layout-transition" style={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                marginLeft: isCollapsed ? "80px" : "260px",
                width: `calc(100% - ${isCollapsed ? "80px" : "260px"})`,
                transition: "all 0.35s cubic-bezier(0.4, 0, 0.2, 1)"
            }}>
                <Navbar toggleSidebar={toggleSidebar} isCollapsed={isCollapsed} />

                <main style={{
                    padding: "32px",
                    maxWidth: "1600px",
                    width: "100%",
                    margin: "0 auto"
                }} className="animate-fade-in">
                    {children}
                </main>
            </div>
        </div>
    );
}

export default Layout;